import { ModelTranslator } from '@/types/ApiResponseTypes'
import { DocumentRequestBody } from '@/types/document/documentResponse'
import { DocumentRequest, isDocumentRequest } from '@/types/document/documentType'

class DocumentRequestTranslator implements ModelTranslator<DocumentRequest> {
  convertToModel(model: any): DocumentRequestBody {
    if (isDocumentRequest(model)) {
      return model
    }
    return { page: 0, pageSize: -1 }
  }
}
export default new DocumentRequestTranslator()
